import { render } from "./PresentProjectsList.vue?vue&type=template&id=3fe1380e"
import script from "./PresentProjectsList.vue?vue&type=script&lang=js"
export * from "./PresentProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__